/**
 * @generated SignedSource<<daf4680ae62cdca786d783268a891b20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNavFilters_user" | "SbRespRefineTopAppliedFilters_user" | "useMeasurementUnit_user">;
  readonly " $fragmentType": "BuyRespTopNav_user";
};
export type BuyRespTopNav_user$key = {
  readonly " $data"?: BuyRespTopNav_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNav_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespTopNavFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "544b89fe6267b5d4d3d63a7208a0f743";

export default node;
